import Balancer from 'react-wrap-balancer';

import { SellingPoint } from './types';
import classNames from 'classnames';

export interface SellingPointsProps {
	testId?: string;
	sellingPoints: SellingPoint[];
	color: 'amber' | 'pink';
}

const SellingPoints = (props: SellingPointsProps) => {
	const { testId = 'SellingPoints', sellingPoints, color } = props;

	const iconClassname = classNames(
		'h-auto w-full max-w-12 md:max-w-14',
		{
			'fill-amber-700': color === 'amber',
		},
		{
			'fill-pink-700': color === 'pink',
		},
	);

	const iconWrapperClassname = classNames(
		'flex-shrink-0 md:rounded-2xl md:p-2',
		{
			'md:bg-amber-50': color === 'amber',
			'md:bg-pink-50': color === 'pink',
		},
	);

	return (
		<div
			className="flex flex-col items-center justify-center gap-10 md:flex-row md:items-start md:gap-6 
					lg:items-start lg:gap-9"
			data-testid={testId}
		>
			{sellingPoints.map((item) => {
				const Icon = item.renderIcon;
				return (
					<div key={item.heading} className="max-w-96 md:text-center">
						<div className="items flex gap-4 md:flex-col md:items-center">
							<div className={iconWrapperClassname}>
								<Icon className={iconClassname} />
							</div>
							<div>
								<strong className="mb-0 inline-block text-xl font-semibold lg:mb-2 lg:text-2xl">
									<Balancer>{item.heading}</Balancer>
								</strong>
								<p className="text-black lg:text-lg">
									<Balancer>{item.content}</Balancer>
								</p>
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default SellingPoints;
